<!-- 车辆出园审批 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table" style="flex-direction: column">
          <!-- 查询条件 -->
          <div class="query">
            <el-form style="margin-top: 10px; transition: all 200ms"
              :class="showSearch ? 'expand searchContent' : 'up searchContent'" :inline="true" ref="search-form"
              label-position="right" label-width="90px" :model="searchForm">
              <el-form-item label="预约园区">
                <el-select v-model="searchForm.appointmentPark" placeholder="请选择">
                  <el-option v-for="item in parkOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="预约日期">
                <el-date-picker type="daterange" value-format="yyyy-MM-dd" placeholder="选择日期"
                  v-model="searchForm.dates"></el-date-picker>
              </el-form-item>
              <el-form-item label="司机姓名">
                <el-input v-model="searchForm.driverName"></el-input>
              </el-form-item>
              <el-form-item label="前车车牌">
                <el-input v-model="searchForm.frontVehicleNumber" />
              </el-form-item>
              <el-form-item label="审批状态">
                <el-checkbox-group v-model="searchForm.appointmentStatus">
                  <el-checkbox v-for="(v, index) in appointmentStatusList" :key="index" :label="v.value">{{ v.label
                  }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="货物类型">
                <el-checkbox-group v-model="searchForm.operateType">
                  <el-checkbox :label="1">装货</el-checkbox>
                  <el-checkbox :label="2">卸货</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="柜号">
                <el-input v-model="searchForm.cabinetNumber" />
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="searchForm.phone" />
              </el-form-item>
            </el-form>

            <div>
              <el-button type="primary" @click="searchResult">{{
                $t("accountGroup.button.query")
              }}</el-button>
              <el-button type="info" @click="resetQuery">{{
                $t("accountGroup.button.reset")
              }}</el-button>
              <el-button type="text" size="medium" v-show="showExpandBtn" style="color: #407aee"
                @click="showSearch = !showSearch" :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'">{{
                  !showSearch ? "展开" : "收起" }}</el-button>
            </div>
          </div>
          <ioc-table ref="exitTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
            @current-change="selectPage" @size-change="changeSize" @selection-change="handleSelectionChange">
            <!-- 上方按钮 -->
            <template slot="menuLeft">
              <el-button size="small" class="iss-operation-button" @click="handelPassCars"
                :disabled="!checkedCarIds.length ? true : false">
                通过
              </el-button>
              <el-button size="small" class="iss-operation-button" @click="handelRejectCars"
                :disabled="!checkedCarIds.length ? true : false">
                拒绝
              </el-button>
              <el-button size="small" class="iss-operation-button" @click="exportOpt">
                导出
              </el-button>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw" style="font-size: 18px;">
                <el-button type="text" icon="el-icon-view"
                  @click="handleView(scope.row, scope.index)"></el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.appointmentStatus == 1" class="item" effect="dark" content="通过" placement="top" popper-class="tooltip-draw" style="font-size: 18px;">
                <el-button v-auth="'/account/index:update'" type="text" icon="el-icon-circle-check"
                  @click="handelPassSingleCar(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.appointmentStatus == 1" class="item" effect="dark" content="拒绝" placement="top" popper-class="tooltip-draw" style="font-size: 18px;">
                <el-button v-auth="'/account/index:delete'" type="text" icon="el-icon-circle-close"
                  @click="handelRejectSingleCar(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <!--详情-->
    <appPanel :width="750" class="app-panel" :isExpand="showPanel" @cancel="handleClosePanel" title="司机出门申请详情">
      <div class="panel-content">
        <el-form style="height: 99%; position: absolute; width: 100%" :inline="true" :model="carDetailInfo"
          ref="carDetailForm" label-width="110px" label-position="right" label-suffix=" :">
          <el-scrollbar style="height: 100%">
            <el-row>
              <el-col :span="12">
                <el-form-item label="司机姓名">
                  <div>
                    {{ carDetailInfo.driverName ? carDetailInfo.driverName : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号">
                  <div>
                    {{ carDetailInfo.phone ? carDetailInfo.phone : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="前车车牌">
                  <div>
                    {{ carDetailInfo.frontVehicleNumber ? carDetailInfo.frontVehicleNumber : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="挂车车牌">
                  <div>
                    {{ carDetailInfo.trailerVehicleNumber ? carDetailInfo.trailerVehicleNumber : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="车辆类型">
                  <div>
                    {{
                      carDetailInfo.vehicleTypeName ? carDetailInfo.vehicleTypeName : "未识别"
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车长">
                  <div>
                    {{
                      carDetailInfo.vehicleLong ? carDetailInfo.vehicleLong : "暂无"
                    }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="园区">
                  {{ carDetailInfo.appointmentParkName ? carDetailInfo.appointmentParkName : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="装/卸货">
                  {{ carDetailInfo.operateTypeName ? carDetailInfo.operateTypeName : "暂无" }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="作业月台">
                  {{ carDetailInfo.platformName ? carDetailInfo.platformName : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="库管">
                  {{ carDetailInfo.inventoryKeeper ? carDetailInfo.inventoryKeeper : "暂无" }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="作业开始时间">
                  <div>
                    {{
                      carDetailInfo.startWorkTime ? carDetailInfo.startWorkTime : "暂无"
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="作业完成时间">
                  <div>
                    {{ carDetailInfo.finishWorkTime ? carDetailInfo.finishWorkTime : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row class="car-info-box">
              <el-col :span="12">
                <el-form-item label="客户">
                  <div>
                    {{ carDetailInfo.custom ? carDetailInfo.custom : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="柜号">
                  <div>
                    {{ carDetailInfo.cabinetNumber ? carDetailInfo.cabinetNumber : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="出园申请时间">
                  <div>
                    {{ carDetailInfo.createTime ? carDetailInfo.createTime : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>
  </div>
</template>
<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/table";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      // 选择的carId
      checkedCarIds: [],
      // 查询条件
      appointmentStatusList: [{
        label: '未审核',
        value: 1
      }, {
        label: '已审核',
        value: 2
      }, {
        label: '已出园',
        value: 3
      }, {
        label: '未通过',
        value: 4
      }],
      goodsType: [],
      searchForm: {
        appointmentPark: "",
        startTime: "",
        endTime: "",
        dates: [],
        driverName: "",
        frontVehicleNumber: "",
        appointmentStatus: [],
        operateType: [],
        cabinetNumber: "",
        phone: ""
      },
      showExpandBtn: false,
      showSearch: true,
      // 下拉选项
      parkOptions: [{
        label: "天津优合进出口有限公司",
        value: "200000001"
      }],
      // 详情数据
      carDetailInfo: {}
    };
  },
  beforeDestroy() { },
  created() { },
  mounted() {
    this.getList();
    this.animation();
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      console.log("--谷峰平--domAry:-", domAry);
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        console.log("--00--");
        this.showExpandBtn = true;
      } else {
        console.log("--111--");
        this.showExpandBtn = false;
      }
    },
    // 获取车辆记录列表
    getList() {
      if (this.searchForm.dates && this.searchForm.dates.length > 0) {
        this.searchForm.startTime = this.searchForm.dates[0]
        this.searchForm.endTime = this.searchForm.dates[1]
      }
      const param = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      this.$fetch(api.exitApproval.queryVehicleAppointmentOutList, param).then(res => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        }
      })
    },

    handleView(row, index) {
      this.showPanel = true;
      this.$fetch(api.exitApproval.queryVehicleAppointmentOut, {
        appointmentId: row.appointmentId
      }).then(res => {
        if (res.success) {
          this.carDetailInfo = res.returnObj;
        }
      })
      // this.form = row;
      // console.log(row.trafficFileCode);
      // if (row.trafficFileCode) {
      //   this.form.trafficFileCode =
      //     "/common/file/downLoadFileStream.json?fileCode=" +
      //     row.trafficFileCode;
      // }
      // console.log("...detail", this.showPanel);
      //  this.$refs.accessTab.rowView(row, index);
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() { },

    handleSelectionChange(items) {
      console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedCarIds = [];
      } else {
        this.checkedCarIds = items.map((item) => {
          return {
            appointmentId: item.appointmentId,
            serialNumber: item.serialNumber
          }
        });
      }
      console.log("----this.checkedCarIds:---", this.checkedCarIds);
    },

    // 查询按钮事件
    searchResult() {
      console.log("---查询--this.searchForm:--", this.searchForm);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchForm = {
        appointmentPark: "",
        startTime: "",
        endTime: "",
        dates: [],
        driverName: "",
        frontVehicleNumber: "",
        appointmentStatus: [],
        operateType: [],
        cabinetNumber: "",
        phone: ""
      }
      console.log("---重置--this.searchForm:--", this.searchForm);
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    // 审批状态改变事件
    handleCheckedSpStatus(value) {
      console.log("--spStatus--value:--", value);
      this.searchForm.spStatus = value;
      console.log("--spStatus--spStatus:--", this.searchForm.spStatus);
    },
    // 货物类型改变事件
    handleCheckedGoodsType(value) {
      console.log("--goodsType--value:--", value);
      this.searchForm.goodsType = value;
      console.log("--goodsType--type:--", this.searchForm.goodsType);
    },

    // 通过单个车辆信息
    handelPassSingleCar(row) {
      this.$confirm("您确定通过该车辆出园申请吗?", "通过确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.carEnterManage.passVehicleAppointment, [{
          appointmentId: row.appointmentId,
          serialNumber: row.serialNumber
        }]).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "通过成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    // 批量通过车辆信息
    handelPassCars() {
      this.$confirm("您确定批量通过所选择的车辆出园申请吗?", "通过确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.carEnterManage.passVehicleAppointment, this.checkedCarIds).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "通过成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    // 拒绝单个车辆信息
    handelRejectSingleCar(row) {
      this.$confirm("您确定拒绝该车辆出园申请吗?", "拒绝确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.carEnterManage.refuseVehicleAppointment, [row.appointmentId]).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "拒绝成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    // 批量拒绝车辆信息
    handelRejectCars() {
      this.$confirm("您确定批量拒绝所选择的车辆出园申请吗?", "拒绝确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.carEnterManage.refuseVehicleAppointment, this.checkedCarIds.map(v => v.appointmentId)).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "拒绝成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    // 导出操作
    exportOpt() {
      this.$confirm("您确定批量导出所选择的车辆出园信息吗?", "导出确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.searchForm.dates && this.searchForm.dates.length > 0) {
          this.searchForm.startTime = this.searchForm.dates[0]
          this.searchForm.endTime = this.searchForm.dates[1]
        }
        const param = {
          ...this.searchForm,
          appointmentType: 2
        }
        this.$fetchDownLoad(api.carEnterManage.exportVehicleAppointmentWorkList, param, {
          responseType: "arraybuffer",
        }).then((response) => {
          if (response.data || response.success) {
            const content = response.data;
            const blob = new Blob([content], {
              type: "application/vnd.ms-excel",
            });
            const fileName =
              "车辆出园信息" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          } else {
            this.$message.error("导出请求失败，请稍后重试");
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;

    .el-form-item {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 8px !important;
      vertical-align: top;
    }
  }

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
